var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-outages-map" },
    [
      _c("div", { staticClass: "c-maps__map", attrs: { id: "projects-map" } }),
      _vm._v(" "),
      _vm.google
        ? _c(
            "GmapMap",
            {
              ref: "gmap",
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                center: _vm.mapConfig.center,
                zoom: _vm.mapConfig.zoom,
                options: {
                  fullscreenControl: false,
                  panControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  overviewMapControl: false,
                  zoomControl: false,
                  zoomControlOptions: {
                    style: _vm.google.maps.ZoomControlStyle.SMALL,
                    position: _vm.google.maps.ControlPosition.BOTTOM_LEFT,
                  },
                },
              },
              on: {
                center_changed: _vm.updateCenter,
                zoom_changed: _vm.updateZoom,
                idle: _vm.sync,
              },
            },
            [
              _c(
                "gmap-cluster",
                _vm._l(_vm.getAllFilteredOutages, function (outage) {
                  return _c("gmap-marker", {
                    key: outage.type + outage.id,
                    attrs: {
                      position: outage.location,
                      clickable: true,
                      icon: {
                        url: _vm.getMarkerIcon(outage),
                        scaledSize: new _vm.google.maps.Size(28, 46),
                      },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.markerClick(outage)
                      },
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }